// Role identifiers shared across the Studio frontend. These mirror the
// role model enforced by the Studio API — change them there first.
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  INTERNAL_ORG_ADMIN: 'internal_org_admin',
  EXTERNAL_ORG_ADMIN: 'external_org_admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
}

// Wager's own staff: the roles that see internal detail (debug data, raw
// evidence, Search's own error text) across products.
export function isInternalRole(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.INTERNAL_ORG_ADMIN
}

// Higher number = more privileged.
export const ROLE_HIERARCHY = {
  [ROLES.VIEWER]: 1,
  [ROLES.EDITOR]: 2,
  [ROLES.EXTERNAL_ORG_ADMIN]: 3,
  [ROLES.INTERNAL_ORG_ADMIN]: 4,
  [ROLES.SUPER_ADMIN]: 5,
}

// Roles an operator can assign from the Users page. super_admin is
// deliberately absent: it is granted out-of-band.
export const ASSIGNABLE_ROLES = [
  { value: ROLES.VIEWER, label: 'Viewer' },
  { value: ROLES.EDITOR, label: 'Editor' },
  { value: ROLES.EXTERNAL_ORG_ADMIN, label: 'External Org Admin' },
  { value: ROLES.INTERNAL_ORG_ADMIN, label: 'Internal Org Admin' },
]

// Formats a role identifier (e.g. "internal_org_admin") as a human label
// (e.g. "Internal Org Admin"). Defaults to viewer for missing/unknown values.
export function formatRoleLabel(role) {
  return (role || ROLES.VIEWER)
    .split('_')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')
}

// Platform resources each organization role may manage. The organization
// context answers for the current organization; a brand switch asks it of the
// next one before leaving the page.
const RESOURCE_ACCESS = {
  [ROLES.SUPER_ADMIN]: ['*'],
  [ROLES.INTERNAL_ORG_ADMIN]: ['resources', 'posts', 'users', 'forms'],
  [ROLES.EXTERNAL_ORG_ADMIN]: ['posts', 'users'],
  [ROLES.EDITOR]: ['posts'],
  [ROLES.VIEWER]: ['posts'],
}

export function canRoleAccessResource(role, resourceType) {
  const access = RESOURCE_ACCESS[role] || []
  return access.includes('*') || access.includes(resourceType)
}
